export default "__VITE_ASSET__ee7786c8__"